import React, { useEffect, useState } from "react"
import { Dialog } from '@headlessui/react'
import { useForm } from "react-hook-form"

import { useUser } from "../../providers/UserProvider"

const plans = [
  { id: 'asap', name: 'I need this ASAP'},
  { id: 'flexible', name: 'I’m flexible'},
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const AdditionalDetails = (props) => {
  const { submitAction, goBack } = props;

  const [user, userDispatch] = useUser();
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: {
      urgency: 'asap',
      details: '',
    }
  });

  const onSubmit = async data => {
    setLoading(true);
    userDispatch({ type: "productRequest/details", payload: { ...data } });
    await submitAction({ ...data });
    setLoading(false);
  };

  const [formReady, setFormReady] = useState(true)

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-4 text-center">
          <Dialog.Title
            as="h3"
            className="text-md leading-7 font-primary font-bold text-convoy-section-title xl:text-xl"
          >
            Almost done!
          </Dialog.Title>
          <div className="mt-3">
            <p className="font-primary text-xxs leading-5 text-grey-footer xl:text-xs">
              Add any additional details about the purchase &amp; let us know how quickly you're looking to make it.
            </p>
          </div>
          <div className="mt-3 text-left">
            <label htmlFor="details" className="block font-primary text-convoy-section-title-smaller text-xxs leading-5">
              Additional details
            </label>
            <div className="mt-1">
              <textarea
                rows={8}
                {...register("details")}
                className="focus:outline-none text-grey-footer placeholder-grey-inputPlaceholderText focus:ring-grey-footer border focus:border-grey-footer block w-full border-grey-inputPreFocusBorder rounded-md font-bold px-3 py-input text-xxs leading-4"
                // defaultValue={}
                placeholder={`Ex: "I'm only interested in the Premium model" or "I'm not brand sensitive so I'd be OK with other manufacturers"`}
              />
            </div>
          </div>
          <div className="mt-3 text-left">
            <label htmlFor="urgency" className="block font-primary text-convoy-section-title-smaller text-xxs leading-5">
              Urgency
            </label>
            <div className="mt-1 relative">
              <fieldset>
                <legend className="sr-only">Plan</legend>
                <div className="space-y-12px">
                  {plans.map((plan) => (
                    <div key={plan.id} className="relative flex items-start">
                      <div className="flex items-center h-5">
                        <input
                          id={plan.id}
                          aria-describedby={`${plan.id}-description`}
                          type="radio"
                          value={plan.id}
                          {...register("urgency", { required: true })}
                          defaultChecked={plan.id === 'asap'}
                          className="focus:outline-none outline-none remove-outline h-5 w-5 text-blue-500 leading border-gray-300"
                        />
                      </div>
                      <div className="ml-3 text-xs">
                        <label htmlFor={plan.id} className="font-bold text-grey-footer text-xxs leading-[1rem]">
                          {plan.name}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </fieldset>
            </div>
          </div>

          <div className="mt-3 flex flex-row">
            <button
              type="button"
              className={"text-xs inline-flex justify-center rounded-100 border border-transparent text-center font-black font-primary text-grey-footer focus:outline-none py-4 leading-buttonText hover:bg-grey-buttonText flex-1"}
              onClick={() => goBack()}
            >
              Go Back
            </button>
            <div className="flex-none w-4"></div>
            <button
              type="submit"
              disabled={!formReady || loading}
              className={"text-xs inline-flex justify-center rounded-100 border border-transparent text-center font-black font-primary text-grey-buttonText focus:outline-none py-4 leading-buttonText flex-1 hover:bg-blue-buttonHover " + classNames(formReady ? "bg-blue-800" : "bg-grey-inputPreFocusBorder")}
            >
              {loading && <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>}
              Continue
            </button>
          </div>

        </div>
      </form>
    </div>
  );
};

export default AdditionalDetails;